import pako from 'pako';
const encodeBase64 = input => {
  if (typeof window !== 'undefined' && typeof btoa === 'function') {
    // Browser environment
    return btoa(String.fromCharCode(...input));
  } else {
    // Node.js environment
    return Buffer.from(input).toString('base64');
  }
};
export const compressString = async function (str, encodeURI) {
  if (encodeURI === void 0) {
    encodeURI = true;
  }
  try {
    const compressedData = pako.gzip(str);
    const base64String = encodeBase64(compressedData);
    return encodeURI ? encodeURIComponent(base64String) : base64String;
  } catch (error) {
    console.error('Failed to compress string', error);
    throw error;
  }
};
//# sourceMappingURL=compressString.js.map